import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Componente } from './interfaces/interfaces';
import { Platform, NavController } from '@ionic/angular';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar, Style } from '@capacitor/status-bar';
import { AutenticacionService } from './providers/autenticacion.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AndroidFullScreen } from '@awesome-cordova-plugins/android-full-screen/ngx';

const setupStatusBar = async () => {
  // Que NO se dibuje por encima del WebView
  await StatusBar.setOverlaysWebView({ overlay: false });

  // Color de fondo del status bar (ajusta al tuyo)
  await StatusBar.setBackgroundColor({ color: '#ffffff' });
  await StatusBar.setStyle({ style: Style.Dark }); // o Style.Light segun tu fondo
};

setupStatusBar().catch(() => {});

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  componentes: Observable<Componente[]>;
  previousUrl: string;
  auxiliar: string;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private autenticacion: AutenticacionService,
    private router: Router,
    private navController: NavController,
    private androidFullScreen: AndroidFullScreen
  ) {
    this.initializeApp();
    this.backButton();
    // this.androidfulll();
  }

  backButton(){
      this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
      //  console.log('prev:', event);
        this.previousUrl = event.url;
      });


    this.platform.backButton.subscribeWithPriority(10, () => {
      if(this.previousUrl.indexOf('/tabs/inicio') >=0 || this.previousUrl == '/login'){
        navigator['app'].exitApp();
      }else if(this.previousUrl.indexOf('/tabs') >=0){
        navigator['app'].exitApp();
      }else{
        this.navController.back();
      }
    });

  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.usuarioLog();
    });
  }

  usuarioLog(){
    this.autenticacion.authState.subscribe(state => {
      if (state) {
      } else {
      }
    });
  }

}
